// Google Maps embed (no API key) for the clinic location.
export default function MapEmbed({ className = "" }) {
  const q = encodeURIComponent("Lisboa 9, Col. Burgos, Cuernavaca, Morelos");
  return (
    <div
      className={`overflow-hidden rounded-2xl border border-line shadow-soft ${className}`}
      data-testid="map-embed"
    >
      <iframe
        title="Ubicación de CESMA en Cuernavaca, Morelos"
        src={`https://www.google.com/maps?q=${q}&output=embed`}
        width="100%"
        height="260"
        style={{ border: 0, display: "block" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
  );
}
